<template>
    <div class="login">
        <b-container class="box">
            <b-row>
                <b-col></b-col>
                <b-col cols="6" class="center">
                    <div class="login-line"></div>
                    <form v-if="login" class="form" v-on:submit.prevent="onSubmit()">
                        <b-form-input class="login-input" type="email" v-model="email" placeholder="E-mail"></b-form-input>
                        <b-form-input class="login-input" type="password" v-model="password" placeholder="Password"></b-form-input>
                        <b-row>
                            <b-col><b-form-checkbox class="login-checkbox" v-model="moreOnline">Resta collegato</b-form-checkbox></b-col>
                            <b-col><a v-on:click="login = false" href="#" style="float: right">Password dimenticata?</a></b-col>
                        </b-row>
                        <b-button type="submit" class="login-submit">Entra</b-button>
                    </form>
                    <div v-if="!login" class="password">
                        <form  v-if="!code" v-on:submit.prevent="onSubmitCode()">
                            <h3>Recupera password</h3>
                            <b-form-input class="login-input" type="email" v-model="emailCode" placeholder="E-mail" style="margin-top: 30px; margin-bottom: 30px;"></b-form-input>
                            <b-row>
                                <b-col><b-button variant="outline-danger" v-on:click="login=true" style="margin-top: 5px">Annulla</b-button></b-col>
                                <b-col><b-button type="submit" size="lg" variant="success" style="float: right">Prosegui</b-button></b-col>
                            </b-row>
                        </form>
                        <h4 v-if="code">Ti abbiamo inviato una mail con tutto il materiale utile per procedere al cambio password al seguente indirizzo:</h4>
                        <h3 v-if="code">{{emailCode}}</h3>
                        <h5 v-if="code">Se non trovi nessuna mail prova fra la posta indesiderata</h5>
                    </div>
                </b-col>
                <b-col></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
    data() {
        return {
            login: true,
            email: "",
            emailCode: "",
            password: "",
            moreOnline: false,
            code: false
        }
    },
    methods: {
        onSubmit() {
            Vue.http.post(this.$hostlink+'user/login', {email: this.email, password: this.password, moreOnline: this.moreOnline}, {credentials : true}).then(response => {
                if(response.body.success){
                    Vue.notify({
                        group: 'global',
                        title: 'Autenticazione eseguita',
                        text: 'Login eseguito con successo!',
                        type: 'success'
                    })
                    Vue.prototype.$isAdmin = response.body.isAdmin
                    this.$router.push('/home')
                }else{
                    Vue.notify({
                        group: 'global',
                        title: 'Autenticazione non eseguita',
                        text: 'Assicurati di aver inserito tutti i dati correttamente!',
                        type: 'error'
                    })
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore!',
                    text: 'Qualcosa è andato storto!',
                    type: 'error'
                })
            })
        },
        onSubmitCode() {
            Vue.http.post(this.$hostlink+'user/sendcode', {email: this.emailCode}, {credentials : true}).then(response => {
                if(response.body.success){
                    Vue.notify({
                        group: 'global',
                        title: 'Successo',
                        text: 'Ti abbiamo inviato una mail con tutto il materiale utile al recupero della password!',
                        type: 'success'
                    })
                    this.code = true
                }else{
                    Vue.notify({
                        group: 'global',
                        title: 'Errore',
                        text: response.body.msg,
                        type: 'error'
                    })
                }
            }, response => {
                Vue.notify({
                    group: 'global',
                    title: 'Errore!',
                    text: 'Qualcosa è andato storto!',
                    type: 'error'
                })
            })
        }
    }
}
</script>

<style>
.login{
    background-image: linear-gradient(to bottom right, #085078, #85D8CE);
    height: 100vh;
}

.box{
    padding-top: 30vh;
}

.form{
    background: white;
    padding: 40px !important;
}

.password{
    background: white;
    padding: 40px !important;
}

.center{
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 0 !important;
}

.login-input{
    background: #d3d3d3 !important;
    margin-bottom: 20px;
    height: 50px !important;
}

.login-input:focus { 
    background: white !important;
}

.login-submit{
    background-color: #085078 !important;
    width: 100%;
    height: 50px;
}

.login-checkbox{
    margin-bottom: 20px;
}

.login-line{
    background: #085078;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    width: 100%;
    height: 4px;
}

@media only screen and (max-width: 600px) {
    .box{
        padding-top: 25vh;
    }

    .center{
        height: 50vh;
        width: 90vw;
    }
}
</style>
